/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gpa_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GPA Calculator (4.0 Scale, Weighted) — Toolverse`)
};

const es_gpa_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Promedio Académico (Escala 4.0, Ponderada) — Toolverse`)
};

const de_gpa_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GPA-Rechner (4,0-Skala, gewichtet) — Toolverse`)
};

const nl_gpa_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GPA Calculator (Schaal van 4,0, Gewogen) — Toolverse`)
};

const fr_gpa_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur de GPA (Échelle 4,0, Pondérée) — Toolverse`)
};

const it_gpa_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore GPA (scala 4.0, ponderato) — Toolverse`)
};

const pt_br2_gpa_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de GPA (Escala 4,0, Ponderada) — Toolverse`)
};

const pt_gpa_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de GPA (Escala de 4,0, Ponderada) — Toolverse`)
};

const ja_gpa_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GPA計算機(4.0スケール、加重平均) — Toolverse`)
};

const zh_gpa_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GPA 计算器（4.0 制，学分加权）— Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gpa_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gpa_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gpa_meta_title", locale)
	if (locale === "en") return en_gpa_meta_title(inputs)
	if (locale === "es") return es_gpa_meta_title(inputs)
	if (locale === "de") return de_gpa_meta_title(inputs)
	if (locale === "nl") return nl_gpa_meta_title(inputs)
	if (locale === "fr") return fr_gpa_meta_title(inputs)
	if (locale === "it") return it_gpa_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_gpa_meta_title(inputs)
	if (locale === "pt") return pt_gpa_meta_title(inputs)
	if (locale === "ja") return ja_gpa_meta_title(inputs)
	return zh_gpa_meta_title(inputs)
};